import axios from 'axios'
import {kyc_docs} from '../../KYCDetails/KYCDetailsDataType'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const ADMIN_LIST_ALL_KYC = `${LOCAL_URL}/admin/kyc/adminListAllKYC`
export const ADMIN_KYC_Details = `${LOCAL_URL}/admin/kyc/adminViewKYC`
export const BUSINESS_TYPE_LIST = `${LOCAL_URL}/admin/kyc/adminBusinessTypeList`
export const KYC_ACCOUNT_DOC_TYPES = `${LOCAL_URL}/admin/kyc/adminKycAccountDocTypes`
export const ADMIN_UPDATE_KYC = `${LOCAL_URL}/admin/kyc/adminUpdateKYC`

const headers = {
  Authorization: API_TOKEN,
}

// function to get business type list
export async function getAdminAllKYCList(offset: number, limit: number) {
  return await axios.post(ADMIN_LIST_ALL_KYC, {offset, limit})
}

// function to get the kyc details
export async function getAdminKYCDetails(account_kyc_uuid: string) {
  return await axios.post(ADMIN_KYC_Details, {account_kyc_uuid})
}

// function to get business type list
export async function getBusinessTypeList() {
  return await axios.get(BUSINESS_TYPE_LIST)
}

// function to get KYC account Doc Type
export async function getKYCAccountDocType() {
  return await axios.get(KYC_ACCOUNT_DOC_TYPES)
}

// function to update the kyc from super admin login
export async function adminUpdateKYC(
  account_kyc_uuid?: string,
  account_kyc_name?: string,
  business_registartion_type_uuid?: string,
  business_name?: string,
  address_1?: string,
  address_2?: string,
  country_id?: number,
  province_id?: number,
  city?: string,
  pin_zip?: string,
  account_holder_name?: string,
  account_no?: string,
  ifsc_swift_code?: string,
  account_email_id?: string,
  account_phone_number?: string,
  account_kyc_status?: number,
  kyc_docs?: kyc_docs[]
) {
  return await axios.post(ADMIN_UPDATE_KYC, {
    account_kyc_uuid,
    account_kyc_name,
    business_registartion_type_uuid,
    business_name,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    account_holder_name,
    account_no,
    ifsc_swift_code,
    account_email_id,
    account_phone_number,
    account_kyc_status,
    kyc_docs,
  })
}
